import Nav from 'emerald-ui/lib/Nav';
import DropdownButton from 'emerald-ui/lib/DropdownButton';
import DropdownItem from 'emerald-ui/lib/DropdownItem';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Nav, componentName: 'Nav' }], 'Nav'),
  description: `The Nav groups a series of items. It can be used inside a Navbar and be collapsed when reaching a set breakpoint in the NavbarComponent.`,
  codeSamples: [
    {
      title: 'Default',
      scope: { DropdownButton, Nav, DropdownItem },
      code: `<Nav>
  <a href="/apps/docs/static" className="active">
    Link 1
  </a>
  <a href="/apps/docs/static">Link 2</a>
  <a href="/apps/docs/static">Link 3</a>
  <DropdownButton title="Dropdown" id="dd1">
    <DropdownItem eventKey="1">Action</DropdownItem>
    <DropdownItem eventKey="2">Another action</DropdownItem>
    <DropdownItem eventKey="3" active>
      Active Item
    </DropdownItem>
    <DropdownItem separator />
    <DropdownItem eventKey="4">Separated link</DropdownItem>
  </DropdownButton>
</Nav>`,
    },
  ],
};
